"use strict";
// Consignee master rules (plan 5.5) and personal-data masking (plan 5.9).
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELIVERED_HERE_MAX_METRES = void 0;
exports.namesMatch = namesMatch;
exports.savedLocationDecision = savedLocationDecision;
exports.maskPhone = maskPhone;
exports.maskName = maskName;
exports.distanceMetres = distanceMetres;
const TITLES = new Set(['mr', 'mrs', 'ms', 'miss', 'dr', 'eng', 'sheikh', 'sir', 'madam']);
function nameTokens(name) {
    return name
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^\p{L}\p{N}]+/gu, ' ')
        .split(' ')
        .filter((t) => t.length > 1 && !TITLES.has(t));
}
/**
 * Is the name on a new order the same person as the name saved with a location?
 * Deliberately strict: the first name must match ("Sara Khan" ~ "Sara K.").
 * Family members sharing a phone ("Omar Rashid" / "Lina Rashid") do not match, so
 * the saved location is only suggested and the dispatcher decides (plan 5.5).
 */
function namesMatch(a, b) {
    const ta = nameTokens(a);
    const tb = nameTokens(b);
    return ta.length > 0 && tb.length > 0 && ta[0] === tb[0];
}
/**
 * Plan 5.5: apply a saved location only when the name matches and the order's
 * district (if known) is the same; otherwise the dispatcher decides.
 */
function savedLocationDecision(input) {
    if (!namesMatch(input.orderName, input.savedName))
        return { action: 'SUGGEST', reason: 'NAME_DIFFERS' };
    if (input.orderDistrictId && input.savedDistrictId && input.orderDistrictId !== input.savedDistrictId) {
        return { action: 'SUGGEST', reason: 'DISTRICT_DIFFERS' };
    }
    return { action: 'APPLY' };
}
/** "+971504829316" → "+971 50 ••• 9316" for lists (full number only when a record is opened, and logged). */
function maskPhone(phone) {
    if (!phone)
        return '—';
    const m = /^\+971(\d{2})\d{3}(\d{4})$/.exec(phone);
    return m ? `+971 ${m[1]} ••• ${m[2]}` : `•••${phone.slice(-4)}`;
}
/** "Sara Khan Ahmed" → "Sara K." for lists. */
function maskName(name) {
    if (!name)
        return '—';
    const parts = name.trim().split(/\s+/);
    return parts.length > 1 ? `${parts[0]} ${parts[1][0].toUpperCase()}.` : parts[0];
}
/** Straight-line distance in metres between two pins. */
function distanceMetres(a, b) {
    const R = 6_371_000;
    const toRad = (d) => (d * Math.PI) / 180;
    const dLat = toRad(b.latitude - a.latitude);
    const dLng = toRad(b.longitude - a.longitude);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(a.latitude)) * Math.cos(toRad(b.latitude)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(h));
}
/** Plan 5.5 "delivered here": GPS must be close to the existing pin (and inside the district — checked in the database). */
exports.DELIVERED_HERE_MAX_METRES = 150;
//# sourceMappingURL=consignee.js.map